import { useState, useEffect } from 'react'

function useIsIOS() {
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    const detectIOS = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const iOSPlatforms = ['iPhone', 'iPad', 'iPod']

      // Check if the platform is specifically an iOS device
      const platformCheck = iOSPlatforms.includes(navigator.platform)

      // Check if the user agent includes iPhone, iPad, or iPod
      const userAgentCheck = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream

      // Modern iOS devices might not list the platform directly, but they support specific APIs
      const isModernIOS = /MacIntel/.test(navigator.platform) && navigator.maxTouchPoints > 1 && !window.MSStream

      return platformCheck || userAgentCheck || isModernIOS
    }

    setIsIOS(detectIOS())
  }, [])

  return isIOS
}

export default useIsIOS

// import { useEffect, useState } from 'react';

// function useIsIOS() {
//     const [isIOS, setIsIOS] = useState(false);

//     useEffect(() => {
//         const checkIsIOS = () => {
//             const userAgent = navigator.userAgent || navigator.vendor || window.opera;

//             // Check for iOS devices based on User-Agent
//             const isIOSDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

//             // Additional checks using platform
//             const isIOSPlatform = /iPad|iPhone|iPod/.test(navigator.platform);

//             // Combine checks
//             setIsIOS(isIOSDevice || isIOSPlatform);
//         };

//         checkIsIOS();
//     }, []);

//     return isIOS;
// }

// export default useIsIOS;
